module.exports = __webpack_public_path__ + "img/2.27d160e2.png";